<div
  id="zoom-wrapper"
  (touchstart)="onTouchStart($event)"
  (touchmove)="onTouchMove($event)"
  (touchend)="onTouchEnd($event)"
>
  <router-outlet></router-outlet>
</div>